import React from 'react';
import { TableBody, TableRow, CircularProgress } from '@mui/material';
import { PAGINATION_LIMIT } from '@src/constants';
import { StyledTableCell } from './index.style';

const CustomTableBody = ({
  columns,
  data,
  loading,
  onRowClick,
  showNumber,
  page,
  bodyStyle,
  limit = PAGINATION_LIMIT,
}) => {
  const handleRowClick = (value) => {
    if (onRowClick) onRowClick(value);
  };

  return (
    <TableBody>
      {loading ? (
        <TableRow className="body-row">
          <StyledTableCell>
            <CircularProgress />
          </StyledTableCell>
        </TableRow>
      ) : (
        data.map((rowData, index) => (
          <TableRow
            className="body-row"
            key={rowData.id}
            onClick={() => handleRowClick(rowData)}
          >
            {showNumber && (
              <StyledTableCell
                className="body-cell"
                align="center"
                bodyStyle={bodyStyle}
              >
                {page * limit + index + 1}
              </StyledTableCell>
            )}
            {columns.map((column) => (
              <StyledTableCell
                width={column.width}
                className="body-cell"
                align={column.align}
                bodyStyle={bodyStyle}
              >
                {column.render ? column.render(rowData) : rowData[column.field]}
              </StyledTableCell>
            ))}
          </TableRow>
        ))
      )}
    </TableBody>
  );
};

export default CustomTableBody;
